import React, { useState } from 'react';
import { Mail, Phone, MapPin, Linkedin, Github, Send } from 'lucide-react';


// ✅ Encore mieux avec .env


const Contact = ({ data }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://ismailessagar.onrender.com/send-email", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const text = await response.text();
      alert(text); // juste pour informer l'utilisateur

      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      alert('Erreur lors de l’envoi : ' + error);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="section-header">
          <span className="label">LET'S WORK TOGETHER</span>
          <h2 className="title-big">CONTACT</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-text">
              <p className="text-regular">
                Ready to let data speak for itself ?
              </p>
              <p className="text-body">
                I'm currently available for new opportunities and excited to discuss 
                how we can leverage data science and machine learning to solve your 
                business challenges.
              </p>
            </div>

            <div className="contact-details">
              <div className="contact-item">
                <Mail size={20} />
                <div className="contact-item-content">
                  <span className="label-small">EMAIL</span>
                  <a href={`mailto:${data.email}`} className="text-body contact-link">
                    {data.email}
                  </a>
                </div>
              </div>

              {/* <div className="contact-item">
                <Phone size={20} />
                <div className="contact-item-content">
                  <span className="label-small">PHONE</span>
                  <a href={`tel:${data.phone}`} className="text-body contact-link">
                    {data.phone}
                  </a>
                </div>
              </div> */}

              <div className="contact-item">
                <MapPin size={20} />
                <div className="contact-item-content">
                  <span className="label-small">LOCATION</span>
                  <span className="text-body">{data.location}</span>
                </div>
              </div>
            </div>

            <div className="social-links">
              <a 
                href={`https://${data.linkedin}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
              >
                <Linkedin size={24} />
                <span className="label-small">LINKEDIN</span>
              </a>
              <a 
                href={`https://${data.github}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
              >
                <Github size={24} />
                <span className="label-small">GITHUB</span>
              </a>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="label-small">NAME</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input text-body"
                  placeholder="Your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="label-small">EMAIL</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input text-body"
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="label-small">SUBJECT</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="form-input text-body"
                  placeholder="Project discussion, collaboration, etc."
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="label-small">MESSAGE</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="form-textarea text-body"
                  placeholder="Tell me about your project or what you'd like to discuss..."
                ></textarea>
              </div>

              <button type="submit" className="btn-accent form-submit">
                <Send size={16} />
                <span>Send Message</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;